import { useEffect, useRef, useState } from "react";
import classes from "./Reveal.module.css";

const Reveal = ({
  as: Tag = "div",
  className = "",
  children = null,
  delay = 0,
  elementRef = null,
  ...props
}) => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;

    if (!node) {
      return undefined;
    }

    const rect = node.getBoundingClientRect();
    const viewportHeight =
      window.innerHeight || document.documentElement.clientHeight;

    if (rect.top < viewportHeight && rect.bottom > 0) {
      setIsVisible(true);
      return undefined;
    }

    if (!("IntersectionObserver" in window)) {
      setIsVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.18,
        rootMargin: "0px 0px -8% 0px",
      }
    );

    observer.observe(node);

    const fallback = window.setTimeout(() => {
      setIsVisible(true);
      observer.disconnect();
    }, 1200);

    return () => {
      window.clearTimeout(fallback);
      observer.disconnect();
    };
  }, []);

  const revealClassName = `${classes.reveal} ${
    isVisible ? classes.visible : ""
  } ${className}`.trim();

  return (
    <Tag
      ref={(node) => {
        ref.current = node;

        if (typeof elementRef === "function") {
          elementRef(node);
        } else if (elementRef) {
          elementRef.current = node;
        }
      }}
      className={revealClassName}
      style={{ transitionDelay: `${delay}ms` }}
      {...props}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
